// extracted by mini-css-extract-plugin
export default {"detail_image":"TenantDetailImage_detail_image__obByF","has_image":"TenantDetailImage_has_image__q2sqv"};